<template>
  
        <div class="myCheckBox">
            <input type="checkbox" class="filled-in" disabled v-model="cellValue"> 
            <label></label>
        </div>
</template>

<script>
    export default {
        data() {
            return {
                cellValue: null
            };
        },
        beforeMount() {
            this.cellValue = this.getValueToDisplay(this.params);
        },
        methods: {
            btnClickedHandler(emit) {
                this.params.clicked({...this.params,emit:emit});
            },
            getValueToDisplay(params) {
                return params.valueFormatted ? params.valueFormatted : params.value;
            }
        }
    }
</script>
<style scoped>
    label{
        height:20px;
        padding-left: 20px;
        margin:0;
    }
</style>
